
import i18n from '../lang/index'
export function generateTitle(item) {
  // 优先使用 DB 中的本地化名称（动态菜单：page_operate / function_operate 的 name_zh / name_en）
  // 菜单数据填充到 route.meta 后，TagsView 传入的 route 对象在 item.meta 上携带 nameZh/nameEn
  // 兼容直接传菜单对象（item.nameZh）和传 route 对象（item.meta.nameZh）两种情况
  let locale = i18n.locale || '';
  let isZh = locale.indexOf('zh') === 0;
  let zhName = item.nameZh || (item.meta && item.meta.nameZh);
  let enName = item.nameEn || (item.meta && item.meta.nameEn);
  if (isZh && zhName) return zhName;
  if (!isZh && enName) return enName;

  // 兜底到原有 i18n 逻辑（静态路由、TagsView、LangSelect 等）
  let hasKey = null;
  let code = item.code || (item.meta && item.meta.code);
  let flag = code ? i18n.te('route.' + code) : false;
  hasKey = code ? (flag ? i18n.t('route.' + code) : i18n.t(item.name)) : i18n.t('route.' + item.name[0].toLocaleLowerCase() + item.name.slice(1))
  return hasKey
}
